angular
  .module('bb.appointments')
  .factory('appointmentListsService', appointmentListsService);

appointmentListsService.$inject = ['$resource'];
function appointmentListsService($resource) {
  function getPermission(listingId) {
    const AppointmentPermissions = $resource(
      '/listing/:listingId/appointments/permissions',
      { listingId },
    );

    return AppointmentPermissions.get({ listingId }).$promise;
  }

  function getListing(listingId) {
    const Listing = $resource('/listing/:listingId', { listingId });

    return Listing.get({ listingId }).$promise;
  }

  function getAppointments(page, limit, listingId, sortBy) {
    const AppointmentPage = $resource(
      '/listing/:listingId/appointments/paginate',
      { listingId },
    );
    return AppointmentPage.get({ page, limit, sortBy }).$promise;
  }

  function getVirtualTourCount(listingId) {
    const VirtualTour = $resource('/listing/:listingId/virtual_tour/count', {
      listingId,
    });
    return VirtualTour.get().$promise;
  }

  function getExternalAppointments(page, limit, dashboardId, sortBy) {
    const ExternalAppointments = $resource('/external/dash/:dashboardId/list', {
      dashboardId,
    });
    return ExternalAppointments.get({ page, limit, sortBy }).$promise;
  }

  function getExternalAppointmentsForListing(
    dashboardId,
    listingId,
    page,
    limit,
    sortBy,
  ) {
    const ExternalAppointmentsForListing = $resource(
      '/external/dash/:dashboardId/appointments/:listingId',
      { dashboardId, listingId },
    );
    return ExternalAppointmentsForListing.get({ page, limit, sortBy }).$promise;
  }

  function getExternalListingConfig(dashboardId, listingId) {
    const ExternalAppointmentsForListing = $resource(
      '/external/dash/:dashboardId/appointment/external_config',
      { dashboardId },
    );
    return ExternalAppointmentsForListing.get({ listingId }).$promise;
  }

  function getExternalBuyerAppointments(page, size, dashboardId) {
    const ExternalAppointments = $resource(
      '/external/dash/:dashboardId/buyer_showings',
      {
        dashboardId,
      },
    );
    return ExternalAppointments.get({ page, size }).$promise;
  }

  function getExternalCustomContactAppointments(page, size, dashboardId) {
    const ExternalCustomContactAppointments = $resource(
      '/external/dash/:dashboardId/custom_contact_showings',
      {
        dashboardId,
      },
    );
    return ExternalCustomContactAppointments.get({ page, size }).$promise;
  }

  return {
    getAppointments,
    getListing,
    getPermission,
    getExternalAppointments,
    getExternalAppointmentsForListing,
    getExternalBuyerAppointments,
    getExternalListingConfig,
    getVirtualTourCount,
    getExternalCustomContactAppointments,
  };
}

export {};
